import React from 'react'
import { connect } from 'react-redux'
import { T } from 'components/Translations'
import Avatar from 'components/Avatar'
import StyledMyAvatar from './StyledMyAvatar'

const MyAvatar = ({ size, user, className }) => (
  <StyledMyAvatar to="/myprofile" className={className}>
    {user.media[0].uri.match(/nophoto/) ? (
      <T as="div" className="avatar no-photo" label="uploadPhotoToBoostChances" />
    ) : (
      <Avatar mine user={user} size={size} />
    )}
  </StyledMyAvatar>
)

export default connect(s => ({ user: s.myProfile }))(MyAvatar)
